import { render, staticRenderFns } from "./CreateVariable.vue?vue&type=template&id=ce23bc22"
import script from "./CreateVariable.vue?vue&type=script&lang=js"
export * from "./CreateVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce23bc22')) {
      api.createRecord('ce23bc22', component.options)
    } else {
      api.reload('ce23bc22', component.options)
    }
    module.hot.accept("./CreateVariable.vue?vue&type=template&id=ce23bc22", function () {
      api.rerender('ce23bc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FormStory/Modals/CreateVariable.vue"
export default component.exports